import { CardRowDetail, CardRowDetailColumn, CardRowDetailLine, CardRowDetailLineSpacer } from "widgets";

import type { MainThreadHoverMessage } from "../../../types.ts";
import { formatRegion } from "../../../utils/region.ts";

export const TrackRegionTooltip = ({
  data,
  contigName,
}: {
  data: Partial<MainThreadHoverMessage>;
  contigName: string | undefined;
}) => {
  return (
    <CardRowDetail>
      <CardRowDetailColumn>
        <CardRowDetailLine title="Name" wrap>
          {data.name}
        </CardRowDetailLine>
        <CardRowDetailLineSpacer />
        <CardRowDetailLine title="Region" wrap>
          {!!data.start &&
            !!data.stop &&
            (contigName != null
              ? formatRegion(contigName, data.start, data.stop)
              : `${data.start.toLocaleString("en-US")} — ${data.stop.toLocaleString("en-US")}`)}
        </CardRowDetailLine>
        <CardRowDetailLine title="Length" wrap>
          {!!data.start && !!data.stop && `${(data.stop - data.start + 1).toLocaleString("en-US")} bp`}
        </CardRowDetailLine>
        <CardRowDetailLine title="Strand">{data.strand}</CardRowDetailLine>
      </CardRowDetailColumn>
    </CardRowDetail>
  );
};
